import {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';

interface ScreenContainerContextType {
  isNerdyInsightModalOpen: boolean;
  setIsNerdyInsightModalOpen: Dispatch<SetStateAction<boolean>>;
}

const defaultState: ScreenContainerContextType = {
  isNerdyInsightModalOpen: false,
  setIsNerdyInsightModalOpen: () => {},
};

const ScreenContainerContext =
  createContext<ScreenContainerContextType>(defaultState);

export const ScreenContainerProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [isNerdyInsightModalOpen, setIsNerdyInsightModalOpen] = useState(false);

  return (
    <ScreenContainerContext.Provider
      value={{
        isNerdyInsightModalOpen,
        setIsNerdyInsightModalOpen,
      }}
    >
      {children}
    </ScreenContainerContext.Provider>
  );
};

export const useScreenContainerContext = () => {
  return useContext(ScreenContainerContext);
};
